import { createHeaders } from './httpHeaderConfig';

// CONVERT TO BELOW IN THE FUTURE
// export const authApiHandler = {
//   getAuthRefreshToken: async (): Promise<AuthResponse> =>
//     createApiClient(apiUrlConfig.BASE_BACKEND_URL).get(`/refresh-token`),
// };

export const getAuthRefreshToken = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/refresh-token`, {
    headers: createHeaders(),
    credentials: 'include',
  });

  //   if (!response.ok) {
  //     logoutUser();
  //   }

  const result: AuthResponse = await response.json();

  return result;
};

export interface AuthResponse {
  token: string;
  user: AuthUser;
  userDetails: {
    forename: string;
    surname: string;
  };
}

export interface AuthUser {
  id: number;
  email: string;
  role: 'admin' | 'superAdmin' | 'user' | 'advisor' | string;
  isAgree: boolean;
  company_id: number;
  created_at: string; // ISO date string
  updated_at: string; // ISO date string
}
